import { useQuery } from "@tanstack/react-query";
import { getMcpStatus } from "../../api/bMcpApi";

export const useGetMcpStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["mcp-status", organisationId],
    queryFn: () => getMcpStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
    onError: (error) => {
      console.error("Error fetching MCP status:", error.response || error);
    },
  });
};
